import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'
import {
  BankingValueObjectsOnboardingCreationSourceValueEnum,
  LegalEntityForSelectFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'
import { getDefaultAlias } from 'modules/banking/utils'

interface Props {
  creationSource: BankingValueObjectsOnboardingCreationSourceValueEnum
  legalEntity: LegalEntityForSelectFragment | null
}

export const ExternalOnboardingExplanationStep = ({ creationSource, legalEntity }: Props) => {
  const purposeLabel = getDefaultAlias(creationSource)

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.new_wizard.step_3_1.side_title')}
      subtitle={i18n.t('banking.accounts.new_wizard.external_onboarding.redirect_description')}
    >
      <Box width="full" flexDirection="column" gap="s16" style={{ maxWidth: '500px' }}>
        <Box flexDirection="row" gap="s16">
          <Box
            padding="s16"
            background="grey100"
            borderRadius={{ all: 'abs008' }}
            flexDirection="column"
            gap="s4"
            style={{ flex: '1' }}
          >
            <F0Text variant="small" content={i18n.t('banking.accounts.new_wizard.step_1.title')} />
            <F0Text variant="body" content={legalEntity?.legalName || '-'} />
          </Box>
          <Box
            padding="s16"
            background="grey100"
            borderRadius={{ all: 'abs008' }}
            flexDirection="column"
            gap="s4"
            style={{ flex: '1' }}
          >
            <F0Text
              variant="small"
              content={i18n.t('banking.accounts.new_wizard.step_1_1.title')}
            />
            <F0Text variant="body" content={purposeLabel ?? ''} />
          </Box>
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
